module.exports = __webpack_public_path__ + "static/media/FD4.daa4245e.png";